import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LeaveService } from 'src/app/providers/leave/leave.service';
import * as moment from 'moment';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';
declare let $: any;
@Component({
  selector: 'app-emp-attendance',
  templateUrl: './emp-attendance.component.html',
  styleUrls: ['./emp-attendance.component.scss'],
})
export class EmpAttendanceComponent implements OnInit {
  @Input() Portlet: 'half' | 'full' = 'half';
  @Input() self: any = '0';
  @Input() empId: any = '';
  isBaseRegular = false;
  attDataRegulariseSelect: any = '';
  attData: any = [];
  result: any = [];
  getRegulariseAttCodeList: any = [];
  getRegulariseAttCodeListCo: any = [];
  historyHeader: any = [];
  attDataRegularise: any = [{ usr_remark: '' }];
  attRegulariseHistory: any = [];
  attRegulariseHistoryDate: any = [];
  public attYear: any = [];

  attMonths: any = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
  ];
  attForm: FormGroup;
  today: any;
  monthName = '';
  ccObj: any = {
    is_a_p_att: 1,
    is_base_offc: 0,
    is_in_out1: 1,
    is_in_out2: 1,
    is_in_out3: 1,
    is_ot: 1,
    is_ot1: 1,
    ot1_limit: '9.00',
    ot_limit: '9.00',
  };

  ccObjBackup: any = {
    is_a_p_att: 1,
    is_base_offc: 0,
    is_in_out1: 1,
    is_in_out2: 1,
    is_in_out3: 1,
    is_ot: 1,
    is_ot1: 1,
    ot1_limit: '9.00',
    ot_limit: '9.00',
  };

  header: any = [
    'In Time',
    'Out Time',
    'OT Hrs',
    'EOT Hrs',
    'Total Hrs',
  ];
  headerBackup: any = [
    'In Time',
    'Out Time',
    'OT Hrs',
    'EOT Hrs',
    'Total Hrs',
  ];

  constructor(
    private leaveServ: LeaveService,
    public formbuilder: FormBuilder,
    private notifyService: NotificationService,
    private location: Location
  ) {
    this.today = moment().format('YYYY-MM-DD');
  }

  ngOnInit(): void {
    this.attFormField();
    const crntmonth = 1 + moment(this.today).month();
    const crntyear = moment(this.today).year();
    const monthName = this.attMonths.filter((val) => val.value == crntmonth);
    this.monthName = monthName[0].label;
    this.attForm.patchValue({
      year: crntyear,
      month: crntmonth,
    });
    this.getAttendance({ ...this.attForm.value, emp_id: this.empId });
    this.getRegulariseAttCode();
    this.makeYear();
  }
  makeYear(): void {
    for (let index = 0; index < 5; index++) {
      let params = {
        value: moment().subtract(index,"years").startOf("year").format('YYYY'),
        label: moment().subtract(index,"years").startOf("year").format('YYYY'),
      }
      this.attYear.push(params);
    }
  }

  back(): void {
    this.location.back();
  }
  getRegulariseAttCode(): void {
    this.leaveServ.getRegulariseAttCode().subscribe(
      (res) => {
        this.result = res;
        this.getRegulariseAttCodeList = this.result.data;
        this.getRegulariseAttCodeListCo = this.result.co;
      },
      (err) => {}
    );
  }

  withdraw(data): void {
    console.table(data);
    let type = data?.req_type || '';
    Swal.fire({
      title:
        'Are you sure you want to widthdraw Request for date ' +
        data.date +
        '?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        if (type == 'Leave') {
          // alert('Leave Withdraw Needs to be wor');
          return;
        }

        this.leaveServ.withdrawRegulariseRqst({ date: data.date }).subscribe(
          (res) => {
            this.result = res;
            if (this.result.status == true) {
              this.notifyService.showSuccess(this.result.msg, '');
              this.getAttendance(this.attForm.value);
            } else {
              this.notifyService.showError(this.result.msg, '');
            }
          },
          (err) => {}
        );
      }
    });
  }
  attFormField(): void {
    this.attForm = this.formbuilder.group({
      year: [''],
      month: [''],
    });
  }

  getAttendance(attData): void {
    //console.log(attData);
    this.leaveServ.getAttendance(attData).subscribe(
      (res) => {
        if (res.status) {
          this.isBaseRegular = res.is_base_regular;
          //console.log(res.data);
          this.attData = res.data;
          this.header = res.header;
          this.ccObj = res.cc_obj;
          const month = this.attForm.value.month;
          const monthName = this.attMonths.filter((val) => val.value == month);
          this.monthName = monthName[0].label;
        } else {
          this.notifyService.showInfo(res.msg, 'Info!');
          this.attData = [];
          this.isBaseRegular = res.is_base_regular;
        }
      },
      (err) => {
        // this.notifyService.showInfo('Error while getting attendance', 'Info!');
        this.attData = [];
        this.header = this.headerBackup;
        this.ccObj = this.ccObjBackup;
      }
    );
  }
  regularise(data): void {
    //console.log(data);
    this.attDataRegularise = [];
    data['usr_remark'] = '';
    this.attDataRegularise.push(data);
    this.attDataRegulariseSelect = data.att ? data.att : '';
    $('#att_regularise').modal({ backdrop: 'static', keyboard: false });
  }

  submitRegularise(): void {
  if (this.attDataRegularise[0].usr_remark == '') {
    Swal.fire('Please enter remark for regularisation', 'error');
    return;
  }

  if (
    this.attDataRegulariseSelect == '' ||
    this.attDataRegulariseSelect == null ||
    this.attDataRegulariseSelect == undefined
  ) {
    Swal.fire('Please Select Attendance to be regularised', 'error');
    return;
  }

  this.attDataRegularise[0]['att'] = this.attDataRegulariseSelect;
  const params = this.attDataRegularise[0];

  // Always require in_time1 & out_time1
  if (!params.in_time1 || params.in_time1 == '') {
    Swal.fire('Please select in time', 'error');
    return;
  }

  if (!params.out_time1 || params.out_time1 == '') {
    Swal.fire('Please select out time', 'error');
    return;
  }

  // OT Hours Validation (min 2, max 8)
  if (params.ot_hrs) {
    const ot = Number(params.ot_hrs);
    if (ot < 2 || ot > 8) {
      Swal.fire('OT hours must be between 2 and 8 hours', 'error');
      return;
    }
  }

  if (params.ot1_hrs) {
    const ot1 = Number(params.ot1_hrs);
    if (ot1 < 2 || ot1 > 8) {
      Swal.fire('EOT hours must be between 2 and 8 hours', 'error');
      return;
    }
  }

  //console.table(params);
  this.leaveServ.initiateRegularise(params).subscribe(
    (res) => {
      this.result = res;
      if (this.result.status == true) {
        $('#att_regularise').modal('hide');
        this.notifyService.showSuccess(this.result.msg);
        this.getAttendance(this.attForm.value);
      } else {
        this.notifyService.showError(this.result.msg);
      }
    },
    (err) => {
      this.notifyService.showError('Internal server error!');
    }
  );
}



  viewHistory(data): void {
    const params = {
      user_id: data.user_id,
      date: data.date,
    };
    this.attRegulariseHistoryDate = data.date;
    this.leaveServ.getRegulariseHistory(params).subscribe(
      (res) => {
        this.result = res;
        if (this.result.status == true) {
          this.attRegulariseHistory = this.result.data;
          this.historyHeader = this.result.header;
          $('#att_regularise_history').modal({
            backdrop: 'static',
            keyboard: false,
          });
        } else {
          this.notifyService.showError(this.result.msg);
          this.attRegulariseHistory = [];
          this.historyHeader = [];
        }
      },
      (err) => {
        this.attRegulariseHistory = [];
        this.historyHeader = [];
        this.notifyService.showError('Internal server error!');
      }
    );
  }

  getAttendanceByClick(): void {
    this.getAttendance({ ...this.attForm.value, emp_id: this.empId });
  }
}

// import { Component, Input, OnInit } from '@angular/core';
// import { Location } from '@angular/common';
// import { FormBuilder, FormGroup } from '@angular/forms';
// import { LeaveService } from 'src/app/providers/leave/leave.service';
// import * as moment from 'moment';
// import { NotificationService } from 'src/app/service/toaster/notification.service';
// import Swal from 'sweetalert2';
// declare let $: any;
// @Component({
//   selector: 'app-emp-attendance',
//   templateUrl: './emp-attendance.component.html',
//   styleUrls: ['./emp-attendance.component.scss']
// })
// export class EmpAttendanceComponent implements OnInit {
//   @Input() Portlet: 'half' | 'full' = 'half';
//   @Input() self: any  = '0';
//   @Input() empId: any  = '';
//   isBaseRegular = false;
//   attDataRegulariseSelect: any = '';
//   attData: any = [];
//   result: any = [];
//   getRegulariseAttCodeList: any = [];
//   getRegulariseAttCodeListCo: any = [];
//   historyHeader: any = [];
//   attDataRegularise: any = [{ usr_remark: '' }];
//   attRegulariseHistory: any = [];
//   attRegulariseHistoryDate: any = [];
//   attYear: any = [
//     { value: 2020, label: '2020' },
//     { value: 2021, label: '2021' },
//     { value: 2022, label: '2022' },
//     { value: 2023, label: '2023' },
//   ];
//   attMonths: any = [
//     { value: 1, label: 'January' },
//     { value: 2, label: 'February' },
//     { value: 3, label: 'March' },
//     { value: 4, label: 'April' },
//     { value: 5, label: 'May' },
//     { value: 6, label: 'June' },
//     { value: 7, label: 'July' },
//     { value: 8, label: 'August' },
//     { value: 9, label: 'September' },
//     { value: 10, label: 'October' },
//     { value: 11, label: 'November' },
//     { value: 12, label: 'December' },
//   ];
//   attForm: FormGroup;
//   today: any;
//   monthName = '';
//   ccObj: any = {
//     is_a_p_att: 1,
//     is_base_offc: 0,
//     is_in_out1: 1,
//     is_in_out2: 1,
//     is_in_out3: 1,
//     is_ot: 1,
//     is_ot1: 1,
//     ot1_limit: '9.00',
//     ot_limit: '9.00',
//   };

//   ccObjBackup: any = {
//     is_a_p_att: 1,
//     is_base_offc: 0,
//     is_in_out1: 1,
//     is_in_out2: 1,
//     is_in_out3: 1,
//     is_ot: 1,
//     is_ot1: 1,
//     ot1_limit: '9.00',
//     ot_limit: '9.00',
//   };

//   header: any = [
//     'OT',
//     'COT',
//     'Shift 1 In Time',
//     'Shift 1 Out Time',
//     'Shift 2 In Time',
//     'Shift 2 Out Time',
//     'Shift 3 In Time',
//     'Shift 3 Out Time',
//   ];
//   headerBackup: any = [
//     'OT',
//     'COT',
//     'Shift 1 In Time',
//     'Shift 1 Out Time',
//     'Shift 2 In Time',
//     'Shift 2 Out Time',
//     'Shift 3 In Time',
//     'Shift 3 Out Time',
//   ];

//   constructor(
//     private leaveServ: LeaveService,
//     public formbuilder: FormBuilder,
//     private notifyService: NotificationService,
//     private location: Location
//   ) {
//     this.today = moment().format('YYYY-MM-DD');
//   }

//   ngOnInit(): void {
//     this.attFormField();
//     const crntmonth = 1 + moment(this.today).month();
//     const crntyear = moment(this.today).year();
//     const monthName = this.attMonths.filter((val) => val.value == crntmonth);
//     this.monthName = monthName[0].label;
//     this.attForm.patchValue({
//       year: crntyear,
//       month: crntmonth,
//       emp_id: this.empId
//     });
//     this.getAttendance(this.attForm.value);
//     this.getRegulariseAttCode();
//   }

//   back(): void {
//     this.location.back();
//   }
//   getRegulariseAttCode(): void {
//     this.leaveServ.getRegulariseAttCode().subscribe(
//       (res) => {
//         this.result = res;
//         this.getRegulariseAttCodeList = this.result.data;
//         this.getRegulariseAttCodeListCo = this.result.co;
//       },
//       (err) => {}
//     );
//   }

//   withdraw(data): void {
//     console.table(data);
//     Swal.fire({
//       title:
//         'Are you sure you want to widthdraw Request for date ' +
//         data.date +
//         '?',
//       text: '',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonText: 'Yes',
//       cancelButtonText: 'No',
//     }).then((result) => {
//       if (result.value) {
//         this.leaveServ.withdrawRegulariseRqst({ date: data.date }).subscribe(
//           (res) => {
//             this.result = res;
//             if (this.result.status == true) {
//               this.notifyService.showSuccess(this.result.msg, '');
//               this.getAttendance(this.attForm.value);
//             } else {
//               this.notifyService.showError(this.result.msg, '');
//             }
//           },
//           (err) => {}
//         );
//       }
//     });
//   }
//   attFormField(): void {
//     this.attForm = this.formbuilder.group({
//       year: [''],
//       month: [''],
//     });
//   }

//   getAttendance(attData): void {
//     this.leaveServ.getAttendance(attData).subscribe(
//       (res) => {
//         if (res.status) {
//           this.isBaseRegular = res.is_base_regular;
//           console.log(res.data);
//           this.attData = res.data;
//           this.header = res.header;
//           this.ccObj = res.cc_obj;
//           const month = this.attForm.value.month;
//           const monthName = this.attMonths.filter((val) => val.value == month);
//           this.monthName = monthName[0].label;
//         } else {
//           this.notifyService.showInfo(res.msg, 'Info!');
//           this.attData = [];
//           this.isBaseRegular = res.is_base_regular;
//         }
//       },
//       (err) => {
//         // this.notifyService.showInfo('Error while getting attendance', 'Info!');
//         this.attData = [];
//         this.header = this.headerBackup;
//         this.ccObj = this.ccObjBackup;
//       }
//     );
//   }
//   regularise(data): void {
//     console.log(data);
//     this.attDataRegularise = [];
//     data['usr_remark'] = '';
//     this.attDataRegularise.push(data);
//     this.attDataRegulariseSelect = data.att ? data.att : '';
//     $('#att_regularise').modal({ backdrop: 'static', keyboard: false });
//   }
//   submitRegularise(): void {
//     if (this.attDataRegularise[0].usr_remark == '') {
//       Swal.fire('Please enter remark for regularisation', 'error');
//       return;
//     }
//     if (
//       this.attDataRegulariseSelect == '' ||
//       this.attDataRegulariseSelect == null ||
//       this.attDataRegulariseSelect == undefined
//     ) {
//       Swal.fire('Please Select Attendance to be regularised', 'error');
//       return;
//     }
//     this.attDataRegularise[0]['att'] = this.attDataRegulariseSelect;
//     const params = this.attDataRegularise[0];

//     if (this.attDataRegularise[0].is_ristrict) {
//       if (!params.in_time1 && params.in_time1 == '') {
//         Swal.fire('Please select in time', 'error');
//         return;
//       }

//       if (!params.out_time1 && params.out_time1 == '') {
//         Swal.fire('Please select out time', 'error');
//         return;
//       }
//     }

//     console.table(params);
//     this.leaveServ.initiateRegularise(params).subscribe(
//       (res) => {
//         this.result = res;
//         if (this.result.status == true) {
//           $('#att_regularise').modal('hide');
//           this.notifyService.showSuccess(this.result.msg);
//           this.getAttendance(this.attForm.value);
//         } else {
//           this.notifyService.showError(this.result.msg);
//         }
//       },
//       (err) => {
//         this.notifyService.showError('Internal server error!');
//       }
//     );
//   }
//   viewHistory(data): void {
//     const params = {
//       user_id: data.user_id,
//       date: data.date,
//     };
//     this.attRegulariseHistoryDate = data.date;
//     this.leaveServ.getRegulariseHistory(params).subscribe(
//       (res) => {
//         this.result = res;
//         if (this.result.status == true) {
//           this.attRegulariseHistory = this.result.data;
//           this.historyHeader = this.result.header;
//           $('#att_regularise_history').modal({
//             backdrop: 'static',
//             keyboard: false,
//           });
//         } else {
//           this.notifyService.showError(this.result.msg);
//           this.attRegulariseHistory = [];
//           this.historyHeader = [];
//         }
//       },
//       (err) => {
//         this.attRegulariseHistory = [];
//         this.historyHeader = [];
//         this.notifyService.showError('Internal server error!');
//       }
//     );
//   }
// }
